module.exports = __webpack_public_path__ + "static/media/resume.40471f27.pdf";